import {DomainDialog} from "src/pages/AdminPage/AddAndUpdateSaas/dialogs/custom/DomainDialog/DomainDialog";

export const Salesforce = () => {
  return (
    <DomainDialog
      placeHolder="Your Salesforce Domain"
      errorLabel="Salesforce Domain required"
      urlPrefix=""
      urlSuffix=""
    />
  )
};
